import clsx from 'clsx';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    variant?: 'card-lg' | 'card-sm' | 'card-xl';
    cardClasses?: string;
}

const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
    { children, className, variant, cardClasses, ...props },
    ref,
) {
    return (
        <div ref={ref} className={clsx('card', variant, className, cardClasses)} {...props}>
            {children}
        </div>
    );
});

export default Card;
